/* Dinero, tablero, pesaje, transporte, aviso y puesto de mercado. */

export function BilleteGlyph() {
  return (
    <>
      <rect x="2.5" y="6" width="19" height="12" rx="2" />
      <circle cx="12" cy="12" r="2.8" />
      <path d="M6 12h.01M18 12h.01" />
    </>
  );
}

export function PizarraGlyph() {
  return (
    <>
      <rect x="3" y="3" width="18" height="12.5" rx="1.8" />
      <path d="M7 7.4h5M7 11h9.5" />
      <path d="M8 15.5L5.6 21M16 15.5L18.4 21M7.2 18.4h9.6" />
    </>
  );
}

export function BalanzaGlyph() {
  return (
    <>
      <path d="M12 4v16.5M8 20.5h8M4.8 7.2h14.4" />
      <path d="M4.8 7.2L2.1 14M4.8 7.2L7.5 14M2.1 14a2.7 2.7 0 0 0 5.4 0Z" />
      <path d="M19.2 7.2L16.5 14M19.2 7.2L21.9 14M16.5 14a2.7 2.7 0 0 0 5.4 0Z" />
    </>
  );
}

export function CamionGlyph() {
  return (
    <>
      <rect x="2" y="6" width="12" height="10.5" rx="1.5" />
      <path d="M14 9.5h4.2l3 3.6v3.4H14M14 13.1h7.2" />
      <circle cx="7" cy="18.4" r="1.9" />
      <circle cx="17.5" cy="18.4" r="1.9" />
    </>
  );
}

export function CampanaGlyph() {
  return (
    <>
      <path d="M6.5 10.5a5.5 5.5 0 0 1 11 0c0 4.6 1.9 6.3 2.8 7.2H3.7c.9-.9 2.8-2.6 2.8-7.2Z" />
      <path d="M12 2.8V5M10 20.5a2.2 2.2 0 0 0 4 0" />
    </>
  );
}

export function MercadoGlyph() {
  return (
    <>
      <path d="M5 4H19L21.6 9.5a3.2 3.2 0 0 1-6.4 0a3.2 3.2 0 0 1-6.4 0a3.2 3.2 0 0 1-6.4 0Z" />
      <path d="M4.5 12.6V20.5M19.5 12.6V20.5M3 20.5h18M4.5 15.5h15" />
    </>
  );
}
